import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, ChatMessage, Flex, Text } from 'pcln-design-system';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import MessageFooter from '../MessageFooter/MessageFooter';
import sanitizeInput from '../../utils/sanitizeInput';
import { useChatMessagesContext } from '../../hooks/useChatMessagesContext';
import FindMyTrips from '../FindMyTrips/FindMyTrips';
import { OtpContextProvider } from '../../context/OtpContext';
const SignOutActions = ({
  submitMessagesFn,
  showOtpForm,
  displayHardCodedMessage = true
}) => {
  var _a;
  const {
    chatMessages
  } = useChatMessagesContext();
  const [showTripForm, setShowTripForm] = useState(false);
  const messageEndRef = useRef(null);
  const lastuserQuestion = (_a = chatMessages.reverse().find(message => message.role === 'user')) === null || _a === void 0 ? void 0 : _a.content;
  const encodedLastUserQuestion = `?openPenny=y${encodeURIComponent('&')}askPrompt=${sanitizeInput(lastuserQuestion)}`;
  const currentPathName = typeof window !== undefined ? window.location.pathname : '/';
  const signOutActionButtons = [{
    name: 'Sign In',
    link: () => {
      window.location.href = `/home/join?flow=authenticate&redirecturl=${currentPathName}${encodedLastUserQuestion}`;
    }
  }, {
    name: 'Find My Trip',
    link: () => {
      window.open('/next-profile/trip-lookup');
    }
  }];
  function handleOtpSubmit(token) {
    submitMessagesFn({
      role: 'assistant',
      content: 'User is trying to access their bookings'
    }, null, {
      'account-less-access-token': token
    });
  }
  useEffect(() => {
    var _a;
    (_a = messageEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  }, [showOtpForm, showTripForm]);
  return React.createElement(React.Fragment, null, React.createElement(Box, null, React.createElement(Flex, {
    mb: 4,
    flexDirection: 'column'
  }, displayHardCodedMessage && React.createElement(ChatMessage, {
    ml: '',
    mb: '20px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 3
    }, "To access your trips, please sign in to your account. Alternatively we can find your trip by providing us some details."), React.createElement(Text, null, "To safeguard your privacy, this chat will be cleared upon signing in.")),
    footer: React.createElement(MessageFooter, null)
  }), React.createElement(Flex, {
    ml: 3,
    mt: 4
  }, signOutActionButtons.map(actionBtns => {
    return React.createElement(Button, {
      key: actionBtns.name,
      mr: 2,
      onClick: function () {
        if (actionBtns.name === 'Find My Trip' && showOtpForm) {
          setShowTripForm(true);
        } else {
          actionBtns.link();
        }
      },
      variation: 'subtle'
    }, actionBtns.name);
  }))), showTripForm ? React.createElement(React.Fragment, null, React.createElement(OtpContextProvider, {
    handleOtpSubmit: handleOtpSubmit
  }, React.createElement(FindMyTrips, null))) : null), React.createElement(Box, {
    ref: messageEndRef
  }));
};
export default SignOutActions;